// Status-Choices (manueller SYNC mit Backend projekte/constants.py!)
export const PROJEKT_STATUS_IN_PLANUNG = 1
export const PROJEKT_STATUS_IN_BEARBEITUNG = 2
export const PROJEKT_STATUS_PAUSIERT = 3
export const PROJEKT_STATUS_ABGESCHLOSSEN = 4

export const PROJEKT_STATUS_CHOICES = [
  { value: PROJEKT_STATUS_IN_PLANUNG, label: 'In Planung' },
  { value: PROJEKT_STATUS_IN_BEARBEITUNG, label: 'In Bearbeitung' },
  { value: PROJEKT_STATUS_PAUSIERT, label: 'Pausiert' },
  { value: PROJEKT_STATUS_ABGESCHLOSSEN, label: 'Abgeschlossen' }
]

// „In Planung"-Farbe (Theme-Token `planning`); Hex muss synchron zum Backend (Schulung
// IN_PLANUNG) sein — Guard-Tests erzwingen es und erklären den Rest im Fehlerfall.
export const PLANNING_COLOR = '#CDDC39'
